<div [libFlexRow]="isMobileView()" [libFlexRowAlign]="'center'" [libFlexRowGap]="isMobileView() ? '8px' : '24px'">
	@if (title(); as title) {
	<div libFlexColumn [libFlexSize]="isMobileView() ? 'full' : '30'" [class.ui-invalid-field]="!isValid()">
		<div libText1>
			{{ title }} @if (isRequired()) {
			<span [class.ui-required]="!isValid()">*</span>
			}
		</div>
		@if (subtitle(); as subtitle) {
		<div libText5>{{ subtitle }}</div>
		}
	</div>
	}
	<div libFlexColumn [libFlexSize]="isMobileView() ? 'full' : 'fill'">
		<dib libFlexRow [libFlexRowAlign]="'center'" [libFlexRowGap]="'16px'">
			<div libFlexColumn libFlexFill>
				<div>
					<ng-content select="[slot=input]"></ng-content>
				</div>
				@if (hint(); as hint) {
				<div class="ui-hint push-top-sm" [innerHTML]="hint"></div>
				}
				<div>
					<ng-content select="[slot=content]"></ng-content>
				</div>
			</div>
			@if (suffix(); as suffix) {
			<div libFlexColumn>
				<div libText5>{{ suffix }}</div>
			</div>
			}
		</dib>
	</div>
</div>
